/* eslint-disable max-len */
/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
import { IBenefit, ICartBenefit } from 'src/interfaces';

import { BenefitsActionType } from '../action-types';
import { BenefitsAction } from '../actions';

export type EnrollmentTypes = 'new_hire' | 'qle' | 'open_enrollment' | 'update_enrollment';
interface BenefitsState {
  loading: boolean;
  error: string | null;
  data: {
    benefits: IBenefit[];
    enrollmentType?: EnrollmentTypes;
    employeeLastBenefitDto: IBenefit[];
    totalDeduction: number;
    isNewHire: boolean;
    isQle: boolean;
    isBenefitUpdate?: boolean;
    isEnrollmentOpen: boolean;
    isOpenEnrollment: boolean;
    daysToEndMonth?: number;
    categoriesToElect?: string[];
    freePlansAvailable?: boolean;
    cart?: ICartBenefit[];
    fetchingCartSession: boolean;
    qleFiles?: unknown[];
  };
}

const benefitDependents: Record<string, string[]> = {
  LIFE_EE: ['VOLADD_EE', 'LIFE_SP', 'VOLADD_SP', 'LIFE_CH', 'VOLADD_CH'],

  VOLADD_EE: ['VOLADD_SP', 'VOLADD_CH'],

  LIFE_SP: ['VOLADD_SP'],

  LIFE_CH: ['VOLADD_CH'],
};

const initialState = {
  loading: false,
  error: null,
  data: {
    benefits: [],
    totalDeduction: 0,
    isNewHire: false,
    isQle: false,
    isBenefitUpdate: false,
    isOpenEnrollment: false,
    isEnrollmentOpen: false,
    daysToEndMonth: 0,
    categoriesToElect: [],
    freePlansAvailable: false,
    employeeLastBenefitDto: [],
    cart: [],
    fetchingCartSession: false,
  },
};

const reducer = (state: BenefitsState = initialState, action: BenefitsAction): BenefitsState => {
  switch (action.type) {
    case BenefitsActionType.GET_BENEFITS:
      return {
        loading: true,
        error: null,
        data: {
          benefits: [],
          totalDeduction: 0,
          isNewHire: false,
          isQle: false,
          isBenefitUpdate: false,
          isEnrollmentOpen: false,
          isOpenEnrollment: false,
          daysToEndMonth: 0,
          cart: state.data.cart,
          fetchingCartSession: true,
          employeeLastBenefitDto: [],
          enrollmentType: state.data.enrollmentType,
          qleFiles: state.data.qleFiles,
        },
      };
    case BenefitsActionType.GET_BENEFITS_SUCCESS:
      return {
        loading: false,
        error: null,
        data: {
          ...action.payload,
          cart: state.data.cart,
          enrollmentType: state.data.enrollmentType,
          qleFiles: state.data.qleFiles,
          fetchingCartSession: false,
          employeeLastBenefitDto: [],
          // employeeLastBenefitDto: action.payload.employeeLastBenefitDto ?? [],
        },
      };
    case BenefitsActionType.GET_BENEFITS_FAILURE:
      return {
        loading: false,
        error: action.payload,
        data: {
          benefits: [],
          totalDeduction: 0,
          isNewHire: false,
          isQle: false,
          isBenefitUpdate: false,
          isEnrollmentOpen: false,
          isOpenEnrollment: false,
          cart: state.data.cart,
          enrollmentType: state.data.enrollmentType,
          qleFiles: state.data.qleFiles,
          fetchingCartSession: false,
          freePlansAvailable: false,
          employeeLastBenefitDto: [],
        },
      };
    case BenefitsActionType.GET_CART_SESSION:
      return {
        loading: true,
        error: null,
        data: {
          ...state.data,
          fetchingCartSession: true,
        },
      };
    case BenefitsActionType.GET_CART_SESSION_SUCCESS:
      return {
        loading: false,
        error: null,
        data: {
          ...state.data,
          cart: action.payload,
          fetchingCartSession: false,
        },
      };
    case BenefitsActionType.GET_CART_SESSION_FAILURE:
      return {
        loading: false,
        error: action.payload,
        data: {
          ...state.data,
          fetchingCartSession: false,
        },
      };

    case BenefitsActionType.UPDATE_CART_SESSION:
      return {
        loading: true,
        error: null,
        data: {
          ...state.data,
        },
      };
    case BenefitsActionType.UPDATE_CART_SESSION_SUCCESS:
      return {
        loading: false,
        error: null,
        data: {
          ...state.data,
        },
      };
    case BenefitsActionType.UPDATE_CART_SESSION_FAILURE:
      return {
        loading: false,
        error: action.payload,
        data: {
          ...state.data,
        },
      };

    case BenefitsActionType.ADD_BENEFIT_TO_CART: {
      const currentCart = state.data.cart ?? [];
      const updatedBenefit = action.payload.benefit;

      // Existing REMOVE behavior
      if (updatedBenefit.action === 'REMOVE') {
        return {
          loading: false,
          error: null,
          data: {
            ...state.data,
            cart: [...currentCart, updatedBenefit],
          },
        };
      }

      // Check whether this benefit already exists in cart.
      // If it exists, this is an EDIT/UPDATE.
      const isEdit = currentCart.some(
        benefit =>
          benefit.benefitId === updatedBenefit.benefitId && benefit.action !== 'REMOVE' && benefit.action !== 'DECLINED'
      );

      let updatedCart = [...currentCart];

      if (isEdit) {
        // Remove the old version of the parent
        updatedCart = updatedCart.filter(benefit => benefit.benefitId !== updatedBenefit.benefitId);

        // Remove dependent children
        const dependents = benefitDependents[updatedBenefit.benefitId] ?? [];

        updatedCart = updatedCart.filter(benefit => !dependents.includes(benefit.benefitId));
      }

      // Add the updated parent
      updatedCart = [updatedBenefit, ...updatedCart];

      return {
        loading: false,
        error: null,
        data: {
          ...state.data,
          cart: updatedCart,
        },
      };
    }

    case BenefitsActionType.REMOVE_BENEFIT_FROM_CART: {
      const benefitToRemove = action.payload.benefit;
      const currentCart = state.data.cart ?? [];

      // Keep the existing DECLINED behavior
      if (benefitToRemove.action === 'DECLINED') {
        const updatedCart = currentCart.filter(benefit => benefit.type !== benefitToRemove.type);

        return {
          loading: false,
          error: null,
          data: {
            ...state.data,
            cart: updatedCart,
          },
        };
      }

      let benefitsToRemove: string[] = [benefitToRemove.benefitId];

      switch (benefitToRemove.benefitId) {
        /**
         * Removing Vol Life - Employee removes:
         * - Vol Life - Employee
         * - Vol AD&D - Employee
         * - Vol Life - Spouse
         * - Vol AD&D - Spouse
         * - Vol Life - Child
         * - Vol AD&D - Child
         */
        case 'LIFE_EE':
          benefitsToRemove = ['LIFE_EE', 'VOLADD_EE', 'LIFE_SP', 'VOLADD_SP', 'LIFE_CH', 'VOLADD_CH'];
          break;

        /**
         * Removing Vol Life - Spouse removes
         * Vol AD&D - Spouse only.
         */
        case 'LIFE_SP':
          benefitsToRemove = ['LIFE_SP', 'VOLADD_SP'];
          break;

        /**
         * Removing Vol Life - Child removes
         * Vol AD&D - Child only.
         */
        case 'LIFE_CH':
          benefitsToRemove = ['LIFE_CH', 'VOLADD_CH'];
          break;

        /**
         * Vol AD&D - Employee is parent of
         * Vol AD&D - Spouse and Vol AD&D - Child.
         *
         * Removing Vol AD&D - Employee removes both.
         */
        case 'VOLADD_EE':
          benefitsToRemove = ['VOLADD_EE', 'VOLADD_SP', 'VOLADD_CH'];
          break;

        /**
         * Removing Vol AD&D - Spouse
         * does not remove any other benefit.
         */
        case 'VOLADD_SP':
          benefitsToRemove = ['VOLADD_SP'];
          break;

        /**
         * Removing Vol AD&D - Child
         * does not remove any other benefit.
         */
        case 'VOLADD_CH':
          benefitsToRemove = ['VOLADD_CH'];
          break;

        default:
          benefitsToRemove = [benefitToRemove.benefitId];
          break;
      }

      const updatedCart = currentCart.filter(benefit => !benefitsToRemove.includes(benefit.benefitId));

      return {
        loading: false,
        error: null,
        data: {
          ...state.data,
          cart: updatedCart,
        },
      };
    }

    case BenefitsActionType.CLEAR_BENEFITS_FROM_CART: {
      return {
        loading: false,
        error: null,
        data: {
          ...state.data,
          cart: action.payload.cart,
        },
      };
    }
    case BenefitsActionType.SET_ENROLLMENT_TYPE:
      return {
        loading: false,
        error: null,
        data: {
          ...state.data,
          enrollmentType: action.payload,
        },
      };
    case BenefitsActionType.SET_QLE_FILES:
      return {
        loading: false,
        error: null,
        data: {
          ...state.data,
          qleFiles: action.payload,
        },
      };
    default:
      return state;
  }
};

export default reducer;
